import { render, staticRenderFns } from "./inviteTask.vue?vue&type=template&id=5778e3c8&scoped=true&"
import script from "./inviteTask.vue?vue&type=script&lang=js&"
export * from "./inviteTask.vue?vue&type=script&lang=js&"
import style0 from "./inviteTask.vue?vue&type=style&index=0&id=5778e3c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5778e3c8",
  null
  
)

export default component.exports